"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasPortfolioGeneratedLoanTapeNormalizedBaseFields = void 0;
const jsonschema_1 = __importDefault(require("jsonschema"));
const schema = __importStar(require("../schema"));
const Log_1 = require("../types/Log");
const hasPortfolioGeneratedLoanTapeNormalizedBaseFields = (obj, logOptions) => {
    const result = jsonschema_1.default.validate(obj, schema.PortfolioGeneratedLoanTapeNormalizedBaseFieldsSchema, { nestedErrors: true });
    if (result.errors.length > 0 && (logOptions === null || logOptions === void 0 ? void 0 : logOptions.logger)) {
        const errorObject = {
            message: 'hasPortfolioGeneratedLoanTapeNormalizedBaseFields typeguard failed',
            metadata: {
                logMeta: {
                    typeguard: 'hasPortfolioGeneratedLoanTapeNormalizedBaseFields',
                    validationErrors: result.errors.map((error) => error.stack),
                },
            },
        };
        logOptions.logger(errorObject, logOptions.logLevel || Log_1.LogLevel.Error);
    }
    return result.valid;
};
exports.hasPortfolioGeneratedLoanTapeNormalizedBaseFields = hasPortfolioGeneratedLoanTapeNormalizedBaseFields;
//# sourceMappingURL=portfolioGeneratedLoanTape.js.map